module.exports = __webpack_public_path__ + "static/media/weather_bg.03b9bb73.jpg";